import {
  Button,
  styled,
  Menu as MenuMui,
  ListSubheader as ListSubheaderMui,
} from '@mui/material';

export const MenuHeader = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const MainButton = styled(Button)`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const CheckedMark = styled('div')`
  width: 36px;
`;

export const Menu = styled(MenuMui)`
  & > .MuiPaper-root {
    padding: 0;
  }
`;

export const MenuContainer = styled('div')`
  padding: 8px 0;
`;

export const ListSubheader = styled(ListSubheaderMui)`
  padding-left: 12px;
  padding-right: 12px;
`;
